import type { CardContent } from '../../types/content'

export function GameCard({ title, eyebrow, description, modifier, status }: CardContent) {
  const visualLabel = title === 'Tecnologia própria' ? '</>' : title.replace('Projeto ', '').toUpperCase()
  return (
    <article className="game-card reveal tilt-card">
      <div className={`card-image ${modifier ?? ''}`}><span>{visualLabel}</span></div>
      <div className="card-body">
        <small>{eyebrow}</small>
        <h3>{title}</h3>
        <p>{description}</p>
        <strong>{status}</strong>
      </div>
    </article>
  )
}
